import { render } from "./QuestionTable.vue?vue&type=template&id=e0731bac"
import script from "./QuestionTable.vue?vue&type=script&lang=ts"
export * from "./QuestionTable.vue?vue&type=script&lang=ts"
script.render = render

export default script